import { Theme } from "@mui/material/styles/createTheme";
import { SxProps } from "@mui/system/styleFunctionSx";

export const sxProps: Record<string, SxProps<Theme>> = {
  welcomeTextPadding: {
    //for pushing line break little to the left
    paddingRight: (theme) => theme.spacing(1),
  },
};
